import {Map, List} from 'immutable';
import {handleActions} from 'redux-actions';

import * as ContactActions from 'web-app/react/entities/contacts/actions';

import * as Actions from './actions';
import Employee from './model';

export default handleActions(
    {
        [Actions.fetchEmployeeSuccess.type]: (state, {payload: {employee, fromAPI}}) =>
            state.update(employee.employeeId, () => {
                return fromAPI ? Employee.fromAPI(employee) : employee;
            }),
        [Actions.fetchAllEmployeesSuccess.type]: (state, {payload: {employees}}) =>
            state.merge(Map(employees.map(e => [e.employeeId, e]))),
        [Actions.updateKeyChildrenSuccess.type]: (state, {payload}) => {
            return state.update(payload.employeeId, employee =>
                employee.merge({keyChildren: List(payload.keyChildren)}),
            );
        },
        [ContactActions.fetchEmployeeContactsSuccess.type]: (state, {payload: {employeeId, contacts}}) =>
            state.update(employeeId, employee => employee.merge({contacts: contacts.keySeq().toList()})),
        [ContactActions.createEmployeeContactSuccess.type]: (state, {payload: {employeeId, contact}}) =>
            state.update(employeeId, employee =>
                employee.merge({contacts: employee.contacts.push(contact.relationId)}),
            ),
        [ContactActions.deleteEmployeeContactSuccess.type]: (state, {payload}) =>
            state.update(payload.employeeId, employee =>
                employee.merge({contacts: employee.contacts.splice(employee.contacts.indexOf(payload.relationId), 1)}),
            ),
    },
    Map(),
);
